import React from 'react';

import { Badge } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import PropTypes from 'prop-types';

import { CLIENT_DISTRIBUTOR_PRODUCT_NATIONAL_SKU } from 'lib/networking/endpoints';
import { CUT_DRY_CLIENT_ID } from 'lib/constants';
import useGet from 'lib/hooks/useGet';

function NationalSkuBadge({ vendorProductId, globalVendor }) {
  const isMdmVendor = globalVendor?.is_mdm_vendor;
  const hasChains = globalVendor?.chains?.length > 0;
  const isMdmOrChained = isMdmVendor || hasChains;

  const { data: { data } = {} } = useGet(
    CLIENT_DISTRIBUTOR_PRODUCT_NATIONAL_SKU,
    {
      product_id: vendorProductId,
      client_id: CUT_DRY_CLIENT_ID,
    },
    !vendorProductId || !isMdmOrChained,
  );

  const isNationalSku = data?.national_sku;

  if (!globalVendor || !isMdmOrChained || !isNationalSku) {
    return null;
  }

  return (
    <Badge className={css(styles.badge)} variant="primary">
      National SKU
    </Badge>
  );
}

const styles = StyleSheet.create({
  badge: {
    marginLeft: 8,
    fontSize: '0.75rem',
    verticalAlign: 'middle',
  },
});

NationalSkuBadge.propTypes = {
  vendorProductId: PropTypes.number,
  globalVendor: PropTypes.shape({
    is_mdm_vendor: PropTypes.bool,
    chains: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }),
};

export default NationalSkuBadge;
